/*
  Aktivierungshilfe - zwei Fragen, eine vollstaendige Anleitung.

  Alles steht schon im Markup: jede Antwort ist ein Knopf, jede
  Diagnose ein Kasten mit `hidden`. Dieses Skript blendet nur um. Faellt
  es aus, sieht der Besucher alle Diagnosen untereinander - unschoen,
  aber vollstaendig lesbar. Genau deshalb liegt der Text in Liquid und
  nicht hier.

  Drei Dinge macht es ausserdem:
  - es haengt die ausgelagerten Teile (Windows zwei, Office) an ihren
    Platz, weil eine einzige Datei zu gross fuers Theme waere,
  - es springt bei jedem Wechsel an den Anfang der Hilfe, damit man
    nicht mitten in einer Anleitung steht,
  - es legt jeden Befehl in die Zwischenablage. Ein Befehl, den man
    abtippt, ist ein Befehl, den man falsch abtippt - gerade bei
    "cscript ospp.vbs /unpkey:".
*/
(function () {
  var wurzel = document.querySelector('[data-ol-dia]');
  if (!wurzel) return;

  /* Die ausgelagerten Teile einsammeln. Ihre Auswahlknoepfe wandern in
     die Gruppe ihres Produkts - gibt es die schon, werden sie dort
     angehaengt; sonst zieht die ganze Gruppe um. Danach ist von der
     Teilung nichts mehr zu merken. Fehlt ein Teil, laeuft der Rest
     unveraendert weiter. */
  (function () {
    var teile = document.querySelectorAll('[data-ol-dia-teil]');
    if (!teile.length) return;
    var zielWahl = wurzel.querySelector('[data-ol-dia-schritt="2"]');
    var zielKarten = wurzel.querySelector('[data-ol-dia-schritt="3"]');
    var anker = zielKarten ? zielKarten.querySelector('.ol-dia__rest') : null;

    Array.prototype.forEach.call(teile, function (teil) {
      var gruppe = teil.querySelector('[data-ol-dia-gruppe]');
      if (gruppe && zielWahl) {
        var name = gruppe.getAttribute('data-ol-dia-gruppe');
        var da = wurzel.querySelector('[data-ol-dia-gruppe="' + name + '"]');
        if (da) {
          while (gruppe.firstChild) da.appendChild(gruppe.firstChild);
        } else {
          zielWahl.appendChild(gruppe);
        }
      }
      if (zielKarten) {
        Array.prototype.forEach.call(teil.querySelectorAll('[data-ol-dia-ergebnis]'), function (k) {
          if (anker) zielKarten.insertBefore(k, anker);
          else zielKarten.appendChild(k);
        });
      }
      if (teil.parentNode) teil.parentNode.removeChild(teil);
    });
  })();

  var schritte = wurzel.querySelectorAll('[data-ol-dia-schritt]');
  var ergebnisse = wurzel.querySelectorAll('[data-ol-dia-ergebnis]');
  var gruppen = wurzel.querySelectorAll('[data-ol-dia-gruppe]');
  var gewaehlt = { produkt: '', fall: '' };
  var erstesMal = true;

  /* Beim Wechsel an den Anfang der Hilfe springen. Canyon scrollt auf
     grossen Schirmen nicht das Dokument, sondern .page-wrapper -
     scrollIntoView trifft beide, window.scrollTo nicht. Beim ersten
     Aufbau (noch vor jeder Klickerei) wird nicht gesprungen. */
  function nachOben() {
    if (erstesMal) { erstesMal = false; return; }
    try {
      wurzel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (e) {
      wurzel.scrollIntoView(true);
    }
  }

  function zeigeSchritt(nr) {
    Array.prototype.forEach.call(schritte, function (s) {
      s.hidden = s.dataset.olDiaSchritt !== String(nr);
    });
    if (nr !== 3) {
      Array.prototype.forEach.call(ergebnisse, function (e) { e.hidden = true; });
    }
    nachOben();
  }

  /* Schritt 2 zeigt nur die Faelle des gewaehlten Programms. */
  function zeigeGruppe(produkt) {
    Array.prototype.forEach.call(gruppen, function (g) {
      g.hidden = g.dataset.olDiaGruppe !== produkt;
    });
  }

  wurzel.addEventListener('click', function (e) {
    var knopf = e.target.closest
      ? e.target.closest('[data-ol-dia-wahl], [data-ol-dia-fall], [data-ol-dia-zurueck], [data-ol-dia-neu]')
      : null;
    if (!knopf) return;

    if (knopf.hasAttribute('data-ol-dia-wahl')) {
      gewaehlt.produkt = knopf.dataset.olDiaWahl;
      zeigeGruppe(gewaehlt.produkt);
      zeigeSchritt(2);
      return;
    }

    if (knopf.hasAttribute('data-ol-dia-fall')) {
      gewaehlt.fall = knopf.dataset.olDiaFall;
      Array.prototype.forEach.call(ergebnisse, function (el) {
        el.hidden = el.dataset.olDiaErgebnis !== gewaehlt.fall;
      });
      zeigeSchritt(3);
      return;
    }

    /* Zurueck steht ueber jeder Auswahl und ueber jeder Anleitung. Die
       Zahl im Attribut sagt, wohin - von der Anleitung zurueck zur
       Liste der Meldungen, von dort zurueck zur Produktwahl. */
    if (knopf.hasAttribute('data-ol-dia-zurueck')) {
      var ziel = parseInt(knopf.getAttribute('data-ol-dia-zurueck'), 10);
      if (!ziel || ziel < 1) ziel = 1;
      if (ziel === 2 && !gewaehlt.produkt) ziel = 1;
      zeigeSchritt(ziel);
      return;
    }

    if (knopf.hasAttribute('data-ol-dia-neu')) {
      gewaehlt = { produkt: '', fall: '' };
      zeigeSchritt(1);
    }
  });

  /* Befehle zum Kopieren. */
  wurzel.addEventListener('click', function (e) {
    var k = e.target.closest ? e.target.closest('[data-ol-dia-cmd]') : null;
    if (!k) return;
    var block = k.closest('.ol-dia__cmd');
    var text = block ? (block.querySelector('code') || {}).textContent : '';
    if (!text) return;
    var alt = k.textContent;
    var fertig = function () {
      k.textContent = k.dataset.fertig || alt;
      k.classList.add('ist-kopiert');
      setTimeout(function () { k.textContent = alt; k.classList.remove('ist-kopiert'); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text.trim()).then(fertig, function () {});
    } else {
      var h = document.createElement('textarea');
      h.value = text.trim();
      document.body.appendChild(h);
      h.select();
      try { document.execCommand('copy'); fertig(); } catch (err) {}
      document.body.removeChild(h);
    }
  });

  zeigeSchritt(1);
})();
